var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1621 8.13357L1.72537 14.91C1.6431 14.9406 1.55379 14.9469 1.46804 14.9282C1.38229 14.9094 1.30372 14.8665 1.24167 14.8045C1.17961 14.7424 1.13667 14.6638 1.11796 14.5781C1.09925 14.4923 1.10555 14.403 1.13611 14.3208L3.19851 8.13357L1.13611 1.94638C1.10555 1.86411 1.09925 1.7748 1.11796 1.68905C1.13667 1.60331 1.17961 1.52474 1.24167 1.46268C1.30372 1.40062 1.38229 1.35769 1.46804 1.33898C1.55378 1.32026 1.6431 1.32656 1.72537 1.35713L16.1621 8.13357Z",
    stroke: "#445386",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.10214429b1c71476e91fe1a782116eac.svg";
export { ForwardRef as ReactComponent };